export { default as Tabs } from './Tabs';
export { default as TabBar } from './TabBar';
export { default as Tab } from './Tab';



// WEBPACK FOOTER //
// /Users/tleunen/dev/react-mdl/src/Tabs/index.js